export const printStyles = {
    hideForPrint: {
        '@media print': {
            display: 'none'
        }
    }
};
